module.exports = __webpack_public_path__ + "img/icon_znks.18fdce40.png";